import { DocumentType } from "../../graphql/generated";
import i18next from "i18next";
import enumLabel from "./enumLabel";

/**
 * Returns a user-friendly label for a DocumentType enum value
 * This provides a specialized label for DocumentType values, using i18n when available
 */
const documentTypeLabel = (
  documentType: DocumentType | undefined | null
): string => {
  if (!documentType) {
    return "N/A";
  }

  return i18next.t(
    `business:documentTypeEnum.${documentType}`,
    enumLabel(documentType) || documentType
  ) as string;
};

export default documentTypeLabel;
